/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CutSelectionStrategy {
    CUTS_ORDERED = 'cutsOrdered',
    ORGS_THRESHOLD = 'orgsThreshold',
    INCS_THRESHOLD = 'incsThreshold',
}
